<template>
  <picture class="media-asset">
    <source
      v-if="imageUrl"
      :data-srcset="formatSrcSet(1480)"
      media="(min-width: 1200px)"
    />
    <source
      v-if="imageUrl"
      :data-srcset="formatSrcSet(1200)"
      media="(min-width: 992px)"
    />
    <source
      v-if="imageUrl"
      :data-srcset="formatSrcSet(992)"
      media="(min-width: 768px)"
    />
    <source
      v-if="imageUrl"
      :data-srcset="formatSrcSet(768)"
      media="(min-width: 576px)"
    />
    <source
      v-if="imageUrl || mobileImageUrl"
      :data-srcset="formatSrcSet(576)"
      media="(min-width: 340px)"
    />
    <source
      v-if="imageUrl || mobileImageUrl"
      :data-srcset="formatSrcSet(340)"
    />
    <img
      :src="formatSrcSet(340, false)"
      :alt="alt"
      :class="modifierClass"
      data-sizes="auto"
      class="media-asset__image lazyload blur-up"
    />
  </picture>
</template>

<script>
export default {
  name: 'ImageSource',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    mobileImageUrl: {
      type: String,
      default: '',
    },
    imageUrl: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: 'image',
    },
    modifierClass: {
      type: String,
      default: '',
    },
  },
  methods: {
    formatSrcSet(size, srcset = true) {
      size = parseInt(size, 10)
      const breakpoint = srcset ? ` ${size}w` : ''
      return `${this.$options.filters.resize(
        this.mobileImageUrl && size < 720 ? this.mobileImageUrl : this.imageUrl,
        size,
        this.blok
      )}${breakpoint}`
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.media-asset {
  width: 100%;
}
</style>
